import classNames from 'classnames'
import { useEffect, useMemo, useState } from 'react'

import { Button } from 'core-components/library/button'
import { IconsList } from 'core-components/library/common'
import { Dropdown } from 'core-components/library/dropdown'
import { Input } from 'core-components/library/inputs'
import { ModalDialog } from 'core-components/library/modalDialog'
import {
  IconButtonPositions,
  LinkButtonColors,
  TextButtonFontSize,
  TLink,
  TLinkButtonColors,
} from 'core-components/library/richTextEditor/interface/Tlink'
import { BaseCrud, Static } from 'core-components/types'

import styles from './ButtonLinkSettings.module.scss'

interface IButtonLinkSettings {
  link: TLink
  setLinkFields: (field: string, value: string | boolean | TLinkButtonColors) => void
}

export const ButtonLinkSettings = (props: IButtonLinkSettings) => {
  const [openModal, setOpenModal] = useState(false)

  const fontSize = useMemo(() => {
    return new BaseCrud({
      fetcher: new Static(TextButtonFontSize),
      keyField: 'name',
    })
  }, [])

  const colorSource = useMemo(() => {
    return new BaseCrud({
      fetcher: new Static(LinkButtonColors),
      keyField: 'name',
    })
  }, [])

  const positions = useMemo(() => {
    return new BaseCrud({
      fetcher: new Static(IconButtonPositions),
      keyField: 'name',
    })
  }, [])

  useEffect(() => {
    setOpenModal(false)
  }, [props.link.icon])

  return (
    <div>
      <ModalDialog
        show={openModal}
        onClose={() => setOpenModal(false)}
        content={() => <IconsList onChange={(value) => props.setLinkFields('icon', value)} />}
      />
      <Dropdown
        source={fontSize}
        caption={'name'}
        label={'font-size'}
        value={props.link.fontSize || ''}
        renderFunction={(item) => {
          return (
            <div className={styles.colorItem}>
              <div>{item.name}</div>
            </div>
          )
        }}
        onChange={(value) => {
          props.setLinkFields('fontSize', value)
        }}
        margin={'md'}
      />
      <Dropdown
        source={colorSource}
        caption={'name'}
        label={'color'}
        value={props.link.backgroundColor || ''}
        renderFunction={(item) => {
          return (
            <div className={styles.colorItem}>
              <div className={classNames(styles.colorPreview, item.value)} />
              <div>{item.name}</div>
            </div>
          )
        }}
        onChange={(value) => {
          props.setLinkFields('backgroundColor', value)
        }}
        margin={'md'}
      />

      <div className={styles.iconSection}>
        <div className={styles.iconInput}>
          <Input
            disabled
            margin={'md'}
            label={'Icon'}
            value={props.link.icon}
            startContent={props.link.icon ? <div className={props.link.icon} /> : undefined}
          />
        </div>

        <Button margin={'md'} iconButton={'kbase kbase-add'} onClick={() => setOpenModal(true)} />

        <Button
          margin={'md'}
          iconButton={'kbase kbase-delete'}
          color={'danger'}
          disabled={!props.link.icon}
          onClick={() => props.setLinkFields('icon', '')}
        />
      </div>

      <Dropdown
        source={positions}
        caption={'name'}
        label={'icon-position'}
        value={props.link.iconPosition || ''}
        renderFunction={(item) => {
          return (
            <div className={styles.colorItem}>
              <div>{item.name}</div>
            </div>
          )
        }}
        onChange={(value) => {
          props.setLinkFields('iconPosition', value)
        }}
        margin={'md'}
      />
    </div>
  )
}
